// extracted by mini-css-extract-plugin
export default {"form":"PasswordConfirmNew_form__n6oWa"};